const Config = {
  EMAIL_FLOWS: {
    key: "EMAIL_FLOWS",
    name: "Mail Flows",
  },
};

export default Config;
